import React, {useState} from "react";
import notify from "../../../../../../components/ACS-Dashboard/ACS-Blocks/Toast";

const ProNumberModal = ({
                            onClose,
                            onSave, // New handler for saving
                            initialProNumber = "", // Initial value for editing
                            isEdit = false, // Flag to indicate if it's edit mode
                            carrierName,
                        }) => {
    const [proNumber, setProNumber] = useState(initialProNumber);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleConfirm = async () => {
        // Validation
        if (!proNumber.trim()) {
            notify.error({
                title: "Missing PRO Number",
                message: "Please enter a PRO number.",
            });
            return;
        }

        if (isSubmitting) return;
        setIsSubmitting(true);

        try {
            // Call the parent's handler with the PRO number
            await onSave(proNumber.trim());
            onClose();
        } catch (error) {
            // Error is already handled in parent function
            console.error("Accept failed:", error);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div
            className="fixed inset-0 z-50 flex items-center justify-center bg-custom-bg-purple bg-opacity-50 dark:bg-black/70 px-4">
            <div
                className="bg-white dark:bg-acs-dark-surface rounded-xl shadow w-full max-w-md p-fluid-3 space-y-fluid-3 border border-gray-200 dark:border-acs-dark-border animate-slide-in">
                {/* Header */}
                <div
                    className="flex justify-between items-center border-b border-gray-300 dark:border-acs-dark-border pb-fluid-2">
                    <h3 className="text-fluid-lg font-semibold text-gray-900 dark:text-acs-dark-text">
                        {isEdit ? "Edit PRO Number" : "Enter PRO Number"}
                    </h3>
                    <button
                        onClick={onClose}
                        className="text-gray-500 dark:text-acs-dark-subtext hover:text-gray-900 dark:hover:text-white text-fluid-xl transition-colors"
                    >
                        ✕
                    </button>
                </div>

                {/* Content */}
                <div className="space-y-fluid-2">
                    <div>
                        <label className="block text-fluid-sm font-medium text-gray-700 dark:text-acs-dark-text mb-1">
                            PRO Number {carrierName && `(${carrierName})`}
                        </label>
                        <input
                            type="text"
                            value={proNumber}
                            onChange={(e) => setProNumber(e.target.value)}
                            placeholder="Enter PRO number"
                            className="w-full border border-gray-300 dark:border-acs-dark-border rounded px-fluid-input-x py-fluid-input-y text-fluid-base bg-white dark:bg-acs-dark-surface text-gray-900 dark:text-acs-dark-text focus:outline-none focus:ring-2 focus:ring-blue-500 dark:focus:ring-[#3B5CCC] transition-colors"
                            disabled={isSubmitting}
                            autoFocus
                        />
                    </div>
                </div>

                {/* Footer Buttons */}
                <div
                    className="flex justify-end gap-fluid-2 pt-fluid-2 border-t border-gray-200 dark:border-acs-dark-border">
                    <button
                        onClick={onClose}
                        className="px-fluid-button-x py-fluid-button-y border border-gray-300 dark:border-[#3B5CCC] text-gray-700 dark:text-acs-dark-text rounded transition-colors hover:bg-gray-100 dark:hover:bg-acs-dark-hover text-fluid-sm disabled:opacity-50 disabled:cursor-not-allowed"
                        disabled={isSubmitting}
                    >
                        Cancel
                    </button>
                    <button
                        onClick={handleConfirm}
                        disabled={!proNumber.trim() || isSubmitting}
                        className={`px-fluid-button-x py-fluid-button-y text-white text-fluid-sm rounded font-semibold transition ${
                            !proNumber.trim() || isSubmitting
                                ? "bg-blue-300 dark:bg-blue-900 cursor-not-allowed"
                                : "bg-blue-600 dark:bg-[#3B5CCC] hover:bg-blue-700 dark:hover:bg-[#4C6EE7]"
                        }`}
                    >
                        {isSubmitting ? (isEdit ? "Updating..." : "Accepting...") : (isEdit ? "Update" : "OK")}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ProNumberModal;